var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_762_16817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1471 60H4.85294C2.17274 60 0 58.0812 0 55.7143V4.28572C0 1.91878 2.17274 0 4.85294 0H37.5L60 19.8701V55.7143C60 58.0812 57.8273 60 55.1471 60Z",
    fill: "url(#paint0_linear_762_16817)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_762_16817)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1471 60H4.85294C2.17274 60 0 58.0812 0 55.7143V4.28572C0 1.91878 2.17274 0 4.85294 0H37.5L60 19.8701V55.7143C60 58.0812 57.8273 60 55.1471 60Z",
    fill: "url(#paint1_linear_762_16817)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27,
    filter: "url(#filter0_f_762_16817)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5879,
    y: 29.0264,
    width: 39.2647,
    height: 16.3636,
    fill: "#0072A2",
    style: {
      mixBlendMode: "darken"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_762_16817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 19.8701H57.3701C46.3962 19.8701 37.5 10.974 37.5 0L60 19.8701Z",
    fill: "url(#paint2_linear_762_16817)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3636 45H9.43466V30.4545H14.4631C15.9072 30.4545 17.1477 30.7457 18.1847 31.3281C19.2263 31.9058 20.0265 32.7367 20.5852 33.821C21.1439 34.9053 21.4233 36.2027 21.4233 37.7131C21.4233 39.2282 21.1416 40.5303 20.5781 41.6193C20.0194 42.7083 19.2121 43.544 18.1562 44.1264C17.1051 44.7088 15.8409 45 14.3636 45ZM12.0696 42.7202H14.2358C15.2491 42.7202 16.0942 42.5355 16.7713 42.1662C17.4484 41.7921 17.9574 41.2358 18.2983 40.4972C18.6392 39.7538 18.8097 38.8258 18.8097 37.7131C18.8097 36.6004 18.6392 35.6771 18.2983 34.9432C17.9574 34.2045 17.4531 33.6529 16.7855 33.2884C16.1226 32.919 15.2988 32.7344 14.3139 32.7344H12.0696V42.7202ZM36.924 37.7273C36.924 39.2945 36.6304 40.6368 36.0433 41.7543C35.4609 42.867 34.6655 43.7192 33.657 44.3111C32.6532 44.9029 31.5144 45.1989 30.2408 45.1989C28.9671 45.1989 27.826 44.9029 26.8175 44.3111C25.8137 43.7145 25.0182 42.8598 24.4311 41.7472C23.8487 40.6297 23.5575 39.2898 23.5575 37.7273C23.5575 36.16 23.8487 34.8201 24.4311 33.7074C25.0182 32.59 25.8137 31.7353 26.8175 31.1435C27.826 30.5516 28.9671 30.2557 30.2408 30.2557C31.5144 30.2557 32.6532 30.5516 33.657 31.1435C34.6655 31.7353 35.4609 32.59 36.0433 33.7074C36.6304 34.8201 36.924 36.16 36.924 37.7273ZM34.2749 37.7273C34.2749 36.6241 34.102 35.6937 33.7564 34.9361C33.4155 34.1738 32.942 33.5985 32.3359 33.2102C31.7299 32.8172 31.0315 32.6207 30.2408 32.6207C29.45 32.6207 28.7517 32.8172 28.1456 33.2102C27.5395 33.5985 27.0637 34.1738 26.718 34.9361C26.3771 35.6937 26.2067 36.6241 26.2067 37.7273C26.2067 38.8305 26.3771 39.7633 26.718 40.5256C27.0637 41.2831 27.5395 41.8584 28.1456 42.2514C28.7517 42.6397 29.45 42.8338 30.2408 42.8338C31.0315 42.8338 31.7299 42.6397 32.3359 42.2514C32.942 41.8584 33.4155 41.2831 33.7564 40.5256C34.102 39.7633 34.2749 38.8305 34.2749 37.7273ZM51.8654 35.3622H49.2092C49.1334 34.9266 48.9937 34.5407 48.7901 34.2045C48.5865 33.8636 48.3332 33.5748 48.0302 33.3381C47.7272 33.1013 47.3815 32.9238 46.9933 32.8054C46.6097 32.6823 46.1954 32.6207 45.7504 32.6207C44.9596 32.6207 44.2589 32.8196 43.6481 33.2173C43.0373 33.6103 42.5591 34.188 42.2134 34.9503C41.8678 35.7079 41.695 36.6335 41.695 37.7273C41.695 38.84 41.8678 39.7775 42.2134 40.5398C42.5638 41.2973 43.042 41.8703 43.6481 42.2585C44.2589 42.642 44.9573 42.8338 45.7433 42.8338C46.1789 42.8338 46.5861 42.777 46.9648 42.6634C47.3484 42.545 47.6916 42.3722 47.9947 42.1449C48.3024 41.9176 48.5605 41.6383 48.7688 41.3068C48.9819 40.9754 49.1287 40.5966 49.2092 40.1705L51.8654 40.1847C51.766 40.8759 51.5505 41.5246 51.2191 42.1307C50.8924 42.7367 50.4639 43.2718 49.9336 43.7358C49.4033 44.1951 48.783 44.5549 48.0728 44.8153C47.3626 45.071 46.5742 45.1989 45.7077 45.1989C44.4293 45.1989 43.2882 44.9029 42.2844 44.3111C41.2807 43.7192 40.4899 42.8646 39.9123 41.7472C39.3346 40.6297 39.0458 39.2898 39.0458 37.7273C39.0458 36.16 39.337 34.8201 39.9194 33.7074C40.5018 32.59 41.2949 31.7353 42.2987 31.1435C43.3024 30.5516 44.4388 30.2557 45.7077 30.2557C46.5174 30.2557 47.2702 30.3693 47.9663 30.5966C48.6623 30.8239 49.2826 31.1577 49.8271 31.598C50.3716 32.0336 50.819 32.5687 51.1694 33.2031C51.5245 33.8329 51.7565 34.5526 51.8654 35.3622Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_762_16817",
    x: -28.4121,
    y: -9.97363,
    width: 117.265,
    height: 94.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_762_16817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_762_16817",
    x: 14.5,
    y: -24,
    width: 72.5,
    height: 69.8701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_762_16817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_762_16817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_762_16817",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_762_16817",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ABDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_762_16817",
    x1: 48.75,
    y1: 0,
    x2: 48.75,
    y2: 19.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocxIcon);
export default __webpack_public_path__ + "static/media/docx-icon.0943d7bf0cc724705e287c449e1e5b1d.svg";
export { ForwardRef as ReactComponent };